import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/undraw_under_construction_46pa.svg")